export const supervisorProjectsMessagesEn = {
  'supervisorProjects.projectDetails.breadcrumb.supervisorProjects': 'Projects',
  'supervisorProjects.projectDetails.tab.overview': 'Overview',
  'supervisorProjects.projectDetails.tab.metrics': 'Metrics',
  'supervisorProjects.header.title': 'Projects',
  'supervisorProjects.summary.totalProjects.title': 'Total projects',
  'supervisorProjects.summary.refStdReview.title': 'Reference standard review',
  'supervisorProjects.summary.inProgressProjects.title': 'In progress',
  'supervisorProjects.summary.completedProjects.title': 'Completed',
  'supervisorProjects.content.table.status.ref_std_review': 'Reference standard review',
  'supervisorProjects.content.table.status.inprogress': 'In progress',
  'supervisorProjects.content.table.status.completed': 'Completed',
  'supervisorProjects.content.table.status.created': 'Created',
  'supervisorProjects.content.table.status.active': 'Active',
};
